module.exports = __webpack_public_path__ + "img/分组 26-2.bd23c818.png";